import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import NavBar from "./components/marginals/navBar";

export default function NotFound() {
	return (
		<>
			<NavBar page="Not Found" userName="" />
			<Container>
				<div>
					<Row>
						<Col xs={12}>
							<h2 style={{ margin: '50px auto', textAlign: 'center' }}>Page not found</h2>
						</Col>
					</Row>
				</div>
			</Container>
		</>
	);
}
